export function isAudioType(type) {
  return type === 'audio/mp4';
}

export function isVideoType(type) {
  return type === 'video/mp4';
}

export function isHttpUrl(value) {
  return typeof value === 'string' && /^https?:\/\//i.test(value);
}

/** Storage object path used by fileValidationApi (not a full URL). */
export function resolveStoragePath(item) {
  if (!item || typeof item !== 'object') return null;
  const candidates = [item.id, item.path, item.storagePath, item.filePath, item.name];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.length && !isHttpUrl(candidate)) {
      return candidate;
    }
  }
  return null;
}

export function storageMediaUrl(filePath) {
  const encoded = encodeURIComponent(filePath);
  return `https://firebasestorage.googleapis.com/v0/b/momentproof-dev2.appspot.com/o/${encoded}?alt=media`;
}

/** URL for <img>/<video>/<audio> — prefers API-provided mediaUrl with access token. */
export function getFileSrc(item) {
  if (!item || typeof item !== 'object') return '';

  const direct = [item.mediaUrl, item.mediaURL, item.url, item.image, item.downloadUrl, item.id].find(
    (value) => typeof value === 'string' && isHttpUrl(value)
  );
  if (direct) return direct;

  const storagePath = resolveStoragePath(item);
  if (!storagePath) return '';

  return storageMediaUrl(storagePath);
}

/** Non-audio/video file entries (e.g. photos, location icons). */
export function shouldShowAsImage(item) {
  if (isAudioType(item?.type) || isVideoType(item?.type)) return false;
  return Boolean(getFileSrc(item));
}
